import { render, staticRenderFns } from "./UpsertNews.vue?vue&type=template&id=5029e5eb"
import script from "./UpsertNews.vue?vue&type=script&lang=ts"
export * from "./UpsertNews.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports